import * as React from 'react'
import { FiSettings } from 'react-icons/fi'

export default function() {
  return (
    <FiSettings
      style={{ marginRight: '5px', minHeight: '16px', minWidth: '16px' }}
    />
  )
}
